"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var message_1 = require("./message");
var calculator_1 = require("./calculator");
var customize_1 = require("./customize");
var reaction_1 = require("../models/reaction");
var random_1 = require("../utilities/random");
var calculator_2 = __importDefault(require("../models/calculator"));
var Client = /** @class */ (function () {
    function Client() {
        this.dragon = null;
        window["receiveMessage"] = this.receiveMessage.bind(this);
    }
    Client.prototype.start = function () {
        var _this = this;
        if (!this.sendMessage(message_1.MESSAGE_NAME.START, {})) {
            // No receiver, use mock data - timeout simulates latency
            setTimeout(function () {
                _this.receiveMockDragon();
                _this.receiveMockQuit();
                _this.receiveMockAchievements();
                _this.receiveMockPark();
                _this.receiveMockInbox();
            }, 200);
        }
    };
    Client.prototype.synchronize = function () {
        this.sendMessage(message_1.MESSAGE_NAME.DRAGON, this.dragon);
    };
    Client.prototype.sendEvent = function (name, parameters) {
        var event = {
            name: "dragon_" + name,
            parameters: parameters
        };
        this.sendMessage(message_1.MESSAGE_NAME.EVENT, event);
    };
    Client.prototype.sendReaction = function (type, value, recipientDragon) {
        var reaction = {
            recipientID: recipientDragon.accountID,
            senderID: this.dragon.accountID,
            senderName: this.dragon.status.name,
            date: new Date(),
            type: type,
            value: value
        };
        this.sendMessage(message_1.MESSAGE_NAME.REACTION, reaction);
    };
    Client.prototype.sendMessage = function (name, body) {
        var _a;
        var android = window["DragonWebInterface"];
        if (android) {
            android.receiveMessage(name, JSON.stringify(body));
            return true;
        }
        var iOS = (_a = window["webkit"]) === null || _a === void 0 ? void 0 : _a.messageHandlers[name];
        if (iOS) {
            iOS.postMessage(JSON.stringify(body));
            return true;
        }
        return false;
    };
    Client.prototype.receiveMessage = function (message) {
        switch (message.name) {
            case message_1.MESSAGE_NAME.DRAGON:
                this.dragon = this.loadDragon(message.body);
                break;
            case message_1.MESSAGE_NAME.QUIT:
                this.quit = this.loadQuit(message.body);
                break;
            case message_1.MESSAGE_NAME.ACHIEVEMENTS:
                this.achievements = this.loadAchievements(message.body);
                break;
            case message_1.MESSAGE_NAME.PARK:
                this.park = this.loadPark(message.body);
                break;
            case message_1.MESSAGE_NAME.INBOX:
                this.inbox = this.loadInbox(message.body);
                break;
            case message_1.MESSAGE_NAME.ACTIVITY:
                this.activityType = this.loadActivity(message.body);
                break;
            default:
                break;
        }
    };
    Client.prototype.award = function (baseXP) {
        var xpMultiplier = calculator_2.default.xpMultiplier(this.dragon.achievements.checkinStreak);
        var xp = baseXP * xpMultiplier;
        this.dragon.status.xp += xp;
        this.sendEvent("xp_awarded", {
            xp_multiplier: xpMultiplier,
            xp_base_earned: baseXP,
            xp_multiplied_earned: xp,
            xp_total: this.dragon.status.xp
        });
    };
    Client.prototype.adjustMeters = function (additions) {
        var e_1, _a;
        var stage = this.dragon.status.stage;
        var lastVisit = this.dragon.status.saved;
        var now = new Date();
        var meterDecay = calculator_2.default.meterDecay(stage, lastVisit, now);
        var meters = this.dragon.meters;
        try {
            for (var _b = __values(Object.keys(meters)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var value = meters[key];
                value -= meterDecay;
                value += additions[key];
                value = Math.min(Math.max(value, 0), 100);
                meters[key] = value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.dragon.status.saved = now;
    };
    Client.prototype.receiveMockDragon = function () {
        var start = new Date();
        start.setUTCDate(start.getUTCDate() - 4);
        var lastSmoked = null;
        var saved = new Date();
        saved.setUTCDate(saved.getUTCDate() - 1);
        this.receiveMessage({
            name: message_1.MESSAGE_NAME.DRAGON,
            body: {
                accountID: "abc",
                status: {
                    showPromo: false,
                    showPrequit: true,
                    name: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                    stage: calculator_1.MAX_STAGE,
                    xp: 2000,
                    level: 1,
                    saved: saved,
                    seenActivities: [],
                },
                quit: {
                    start: start,
                    lastSmoked: lastSmoked,
                    dailyCigarettes: 5,
                },
                achievements: {
                    missionsCompleted: 1,
                    diariesRecorded: 6,
                    cravingsRecorded: 0,
                    wishlistItemsAdded: 0,
                    tipsFavourited: 0,
                    parkReactions: 0,
                    checkinStreak: 3
                },
                meters: {
                    calmness: 81,
                    nutrition: 76,
                    hygiene: 90,
                    energy: 74
                },
                unlocks: {
                    backdrop: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.backdrop.elements),
                    body: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements),
                    eyes: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements),
                    head: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.head.elements),
                    breath: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.breath.elements),
                    scales: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.scales.elements),
                    wings: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.wings.elements),
                    tail: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.tail.elements),
                    hat: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.hat.elements),
                    collar: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.collar.elements),
                    band: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.band.elements),
                },
                appearance: {
                    backdrop: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.backdrop.elements)),
                    body: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements)),
                    eyes: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements)),
                    head: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.head.elements)),
                    breath: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.breath.elements)),
                    scales: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.scales.elements)),
                    wings: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.wings.elements)),
                    tail: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.tail.elements)),
                    hat: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.hat.elements)),
                    collar: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.collar.elements)),
                    band: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.band.elements)),
                }
            }
        });
    };
    Client.prototype.receiveMockQuit = function () {
        var start = new Date();
        start.setUTCDate(start.getUTCDate() - 4);
        var lastSmoked = null;
        this.receiveMessage({
            name: message_1.MESSAGE_NAME.QUIT,
            body: {
                start: start,
                lastSmoked: lastSmoked,
                dailyCigarettes: 5,
            }
        });
    };
    Client.prototype.receiveMockAchievements = function () {
        this.receiveMessage({
            name: message_1.MESSAGE_NAME.ACHIEVEMENTS,
            body: {
                missionsCompleted: 1,
                diariesRecorded: 6,
                cravingsRecorded: 0,
                wishlistItemsAdded: 0,
                tipsFavourited: 0,
                parkReactions: 0,
                checkinStreak: 3
            }
        });
    };
    Client.prototype.receiveMockPark = function () {
        var start = new Date();
        start.setUTCDate(start.getUTCDate() - 4);
        this.receiveMessage({
            name: message_1.MESSAGE_NAME.PARK,
            body: {
                dragons: [{
                        accountID: "def",
                        status: {
                            name: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                            stage: (0, random_1.randomNumber)(9)
                        },
                        quit: {
                            start: start,
                            lastSmoked: null,
                            dailyCigarettes: 5 + (0, random_1.randomNumber)(30),
                        },
                        achievements: {
                            missionsCompleted: (0, random_1.randomNumber)(50),
                            diariesRecorded: (0, random_1.randomNumber)(40),
                            cravingsRecorded: (0, random_1.randomNumber)(200),
                            wishlistItemsAdded: (0, random_1.randomNumber)(10),
                            tipsFavourited: (0, random_1.randomNumber)(10),
                            parkReactions: (0, random_1.randomNumber)(15)
                        },
                        unlocks: {
                            backdrop: [],
                            body: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements),
                            eyes: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements),
                            head: [],
                            breath: [],
                            scales: [],
                            wings: [],
                            tail: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.tail.elements),
                            hat: [],
                            collar: [],
                            band: [],
                        },
                        appearance: {
                            backdrop: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.backdrop.elements)),
                            body: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements)),
                            eyes: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements)),
                            head: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.head.elements)),
                            breath: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.breath.elements)),
                            scales: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.scales.elements)),
                            wings: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.wings.elements)),
                            tail: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.tail.elements)),
                            hat: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.hat.elements)),
                            collar: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.collar.elements)),
                            band: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.band.elements)),
                        }
                    }, {
                        accountID: "ghi",
                        status: {
                            name: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                            stage: (0, random_1.randomNumber)(9)
                        },
                        quit: {
                            start: start,
                            lastSmoked: null,
                            dailyCigarettes: 5 + (0, random_1.randomNumber)(30),
                        },
                        achievements: {
                            missionsCompleted: (0, random_1.randomNumber)(50),
                            diariesRecorded: (0, random_1.randomNumber)(40),
                            cravingsRecorded: (0, random_1.randomNumber)(200),
                            wishlistItemsAdded: (0, random_1.randomNumber)(10),
                            tipsFavourited: (0, random_1.randomNumber)(10),
                            parkReactions: (0, random_1.randomNumber)(15)
                        },
                        unlocks: {
                            backdrop: [],
                            body: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements),
                            eyes: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements),
                            head: [],
                            breath: [],
                            scales: [],
                            wings: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.wings.elements),
                            tail: [],
                            hat: [],
                            collar: [],
                            band: [],
                        },
                        appearance: {
                            backdrop: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.backdrop.elements)),
                            body: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements)),
                            eyes: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements)),
                            head: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.head.elements)),
                            breath: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.breath.elements)),
                            scales: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.scales.elements)),
                            wings: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.wings.elements)),
                            tail: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.tail.elements)),
                            hat: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.hat.elements)),
                            collar: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.collar.elements)),
                            band: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.band.elements)),
                        }
                    }, {
                        accountID: "lmn",
                        status: {
                            name: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                            stage: (0, random_1.randomNumber)(9)
                        },
                        quit: {
                            start: start,
                            lastSmoked: null,
                            dailyCigarettes: 5 + (0, random_1.randomNumber)(30),
                        },
                        achievements: {
                            missionsCompleted: (0, random_1.randomNumber)(50),
                            diariesRecorded: (0, random_1.randomNumber)(40),
                            cravingsRecorded: (0, random_1.randomNumber)(200),
                            wishlistItemsAdded: (0, random_1.randomNumber)(10),
                            tipsFavourited: (0, random_1.randomNumber)(10),
                            parkReactions: (0, random_1.randomNumber)(15)
                        },
                        unlocks: {
                            backdrop: [],
                            body: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements),
                            eyes: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements),
                            head: [],
                            breath: Object.keys(customize_1.CUSTOMIZE_CATEGORIES.breath.elements),
                            scales: [],
                            wings: [],
                            tail: [],
                            hat: [],
                            collar: [],
                            band: []
                        },
                        appearance: {
                            backdrop: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.backdrop.elements)),
                            body: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements)),
                            eyes: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements)),
                            head: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.head.elements)),
                            breath: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.breath.elements)),
                            scales: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.scales.elements)),
                            wings: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.wings.elements)),
                            tail: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.tail.elements)),
                            hat: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.hat.elements)),
                            collar: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.collar.elements)),
                            band: (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.band.elements)),
                        }
                    }]
            }
        });
    };
    Client.prototype.receiveMockInbox = function () {
        this.receiveMessage({
            name: message_1.MESSAGE_NAME.INBOX,
            body: {
                reactions: [{
                        recipientID: "abc",
                        senderID: "def",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "emoji",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.emoji)
                    }, {
                        recipientID: "abc",
                        senderID: "ghi",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "message",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.message)
                    }, {
                        recipientID: "abc",
                        senderID: "ghi",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "emoji",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.emoji)
                    }, {
                        recipientID: "abc",
                        senderID: "ghi",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "message",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.message)
                    }, {
                        recipientID: "abc",
                        senderID: "ghi",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "message",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.message)
                    }, {
                        recipientID: "abc",
                        senderID: "ghi",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "emoji",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.emoji)
                    }, {
                        recipientID: "abc",
                        senderID: "ghi",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "message",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.message)
                    }, {
                        recipientID: "abc",
                        senderID: "ghi",
                        senderName: (0, random_1.randomValue)(["Emerald", "Saphire", "Rose", "Jasper", "Ruby", "Amber", "Beryl", "Jet", "Jade", "Mica", "Onyx", "Opal"]),
                        date: new Date(),
                        type: "emoji",
                        value: (0, random_1.randomValue)(reaction_1.REACTION_CATEGORIES.emoji)
                    }]
            }
        });
    };
    Client.prototype.loadDragon = function (body) {
        var _a, _b, _c, _d, _e, _f;
        return {
            accountID: body["accountID"],
            status: this.loadStatus((_a = body["status"]) !== null && _a !== void 0 ? _a : []),
            quit: this.loadQuit((_b = body["quit"]) !== null && _b !== void 0 ? _b : []),
            achievements: this.loadAchievements((_c = body["achievements"]) !== null && _c !== void 0 ? _c : []),
            meters: this.loadMeters((_d = body["meters"]) !== null && _d !== void 0 ? _d : []),
            unlocks: this.loadUnlocks((_e = body["unlocks"]) !== null && _e !== void 0 ? _e : []),
            appearance: this.loadAppearance((_f = body["appearance"]) !== null && _f !== void 0 ? _f : [])
        };
    };
    Client.prototype.loadStatus = function (body) {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            showPromo: (_a = body["showPromo"]) !== null && _a !== void 0 ? _a : false,
            showPrequit: (_b = body["showPrequit"]) !== null && _b !== void 0 ? _b : false,
            name: body["name"],
            stage: (_c = body["stage"]) !== null && _c !== void 0 ? _c : 0,
            xp: (_d = body["xp"]) !== null && _d !== void 0 ? _d : calculator_1.BASE_XP,
            level: (_e = body["level"]) !== null && _e !== void 0 ? _e : 1,
            saved: new Date((_f = body["saved"]) !== null && _f !== void 0 ? _f : Date.now()),
            seenActivities: (_g = body["seenActivities"]) !== null && _g !== void 0 ? _g : []
        };
    };
    Client.prototype.loadMeters = function (body) {
        var _a, _b, _c, _d;
        return {
            calmness: (_a = body["calmness"]) !== null && _a !== void 0 ? _a : 100,
            nutrition: (_b = body["nutrition"]) !== null && _b !== void 0 ? _b : 100,
            hygiene: (_c = body["hygiene"]) !== null && _c !== void 0 ? _c : 100,
            energy: (_d = body["energy"]) !== null && _d !== void 0 ? _d : 100
        };
    };
    Client.prototype.loadUnlocks = function (body) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return {
            backdrop: (_a = body["backdrop"]) !== null && _a !== void 0 ? _a : ["meadow"],
            body: (_b = body["body"]) !== null && _b !== void 0 ? _b : Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements),
            eyes: (_c = body["eyes"]) !== null && _c !== void 0 ? _c : Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements),
            head: (_d = body["head"]) !== null && _d !== void 0 ? _d : ["aggressive"],
            breath: (_e = body["breath"]) !== null && _e !== void 0 ? _e : ["red_fire"],
            scales: (_f = body["scales"]) !== null && _f !== void 0 ? _f : ["aggressive"],
            wings: (_g = body["wings"]) !== null && _g !== void 0 ? _g : ["small"],
            tail: (_h = body["tail"]) !== null && _h !== void 0 ? _h : ["aggressive"],
            hat: (_j = body["hat"]) !== null && _j !== void 0 ? _j : ["none"],
            collar: (_k = body["collar"]) !== null && _k !== void 0 ? _k : ["none"],
            band: (_l = body["band"]) !== null && _l !== void 0 ? _l : ["none"]
        };
    };
    Client.prototype.loadAppearance = function (body) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return {
            backdrop: (_a = body["backdrop"]) !== null && _a !== void 0 ? _a : "meadow",
            body: (_b = body["body"]) !== null && _b !== void 0 ? _b : (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.body.elements)),
            eyes: (_c = body["eyes"]) !== null && _c !== void 0 ? _c : (0, random_1.randomValue)(Object.keys(customize_1.CUSTOMIZE_CATEGORIES.eyes.elements)),
            head: (_d = body["head"]) !== null && _d !== void 0 ? _d : "aggressive",
            breath: (_e = body["breath"]) !== null && _e !== void 0 ? _e : "red_fire",
            scales: (_f = body["scales"]) !== null && _f !== void 0 ? _f : "aggressive",
            wings: (_g = body["wings"]) !== null && _g !== void 0 ? _g : "small",
            tail: (_h = body["tail"]) !== null && _h !== void 0 ? _h : "aggressive",
            hat: (_j = body["hat"]) !== null && _j !== void 0 ? _j : "none",
            collar: (_k = body["collar"]) !== null && _k !== void 0 ? _k : "none",
            band: (_l = body["band"]) !== null && _l !== void 0 ? _l : "none"
        };
    };
    Client.prototype.loadQuit = function (body) {
        var _a, _b;
        return {
            start: new Date((_a = body["start"]) !== null && _a !== void 0 ? _a : Date.now()),
            lastSmoked: body["lastSmoked"] ? new Date(body["lastSmoked"]) : null,
            dailyCigarettes: (_b = body["dailyCigarettes"]) !== null && _b !== void 0 ? _b : 0,
        };
    };
    Client.prototype.loadAchievements = function (body) {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            missionsCompleted: (_a = body["missionsCompleted"]) !== null && _a !== void 0 ? _a : 0,
            diariesRecorded: (_b = body["diariesRecorded"]) !== null && _b !== void 0 ? _b : 0,
            cravingsRecorded: (_c = body["cravingsRecorded"]) !== null && _c !== void 0 ? _c : 0,
            wishlistItemsAdded: (_d = body["wishlistItemsAdded"]) !== null && _d !== void 0 ? _d : 0,
            tipsFavourited: (_e = body["tipsFavourited"]) !== null && _e !== void 0 ? _e : 0,
            parkReactions: (_f = body["parkReactions"]) !== null && _f !== void 0 ? _f : 0,
            checkinStreak: (_g = body["checkinStreak"]) !== null && _g !== void 0 ? _g : 0
        };
    };
    Client.prototype.loadPark = function (body) {
        var _this = this;
        return {
            dragons: body["dragons"].map(function (dragonBody) {
                return _this.loadDragon(dragonBody);
            })
        };
    };
    Client.prototype.loadInbox = function (body) {
        var _this = this;
        return {
            reactions: body["reactions"].map(function (reactionBody) {
                return _this.loadReaction(reactionBody);
            })
        };
    };
    Client.prototype.loadActivity = function (body) {
        return body["type"];
    };
    Client.prototype.loadReaction = function (body) {
        var _a;
        return {
            recipientID: body["recipientID"],
            senderID: body["senderID"],
            senderName: body["senderName"],
            date: new Date((_a = body["date"]) !== null && _a !== void 0 ? _a : Date.now()),
            type: body["type"],
            value: body["value"]
        };
    };
    return Client;
}());
exports.default = Client;
